__turbopack_context__.v({
  "activeIndicator": "navigation-item-module__p0NNDW__activeIndicator",
  "backdrop": "navigation-item-module__p0NNDW__backdrop",
  "expandedLayer": "navigation-item-module__p0NNDW__expandedLayer",
  "expandedLayerActive": "navigation-item-module__p0NNDW__expandedLayerActive",
  "icon": "navigation-item-module__p0NNDW__icon",
  "iconColorActive": "navigation-item-module__p0NNDW__iconColorActive",
  "iconColorDefault": "navigation-item-module__p0NNDW__iconColorDefault",
  "iconSpacer": "navigation-item-module__p0NNDW__iconSpacer",
  "iconStage": "navigation-item-module__p0NNDW__iconStage",
  "iconStageCollapsed": "navigation-item-module__p0NNDW__iconStageCollapsed",
  "iconSvg": "navigation-item-module__p0NNDW__iconSvg",
  "indicator": "navigation-item-module__p0NNDW__indicator",
  "indicatorClosing": "navigation-item-module__p0NNDW__indicatorClosing",
  "itemLabel": "navigation-item-module__p0NNDW__itemLabel",
  "itemLabelColorActive": "navigation-item-module__p0NNDW__itemLabelColorActive",
  "itemLabelColorDefault": "navigation-item-module__p0NNDW__itemLabelColorDefault",
  "labelClosing": "navigation-item-module__p0NNDW__labelClosing",
  "labelOpening": "navigation-item-module__p0NNDW__labelOpening",
  "menuButton": "navigation-item-module__p0NNDW__menuButton",
  "nav-menu-indicator-fade-out": "navigation-item-module__p0NNDW__nav-menu-indicator-fade-out",
  "nav-menu-label-fade-in": "navigation-item-module__p0NNDW__nav-menu-label-fade-in",
  "nav-menu-label-fade-out": "navigation-item-module__p0NNDW__nav-menu-label-fade-out",
  "root": "navigation-item-module__p0NNDW__root",
  "rootClosing": "navigation-item-module__p0NNDW__rootClosing",
  "rootCollapsed": "navigation-item-module__p0NNDW__rootCollapsed",
  "rootWithExpandedRow": "navigation-item-module__p0NNDW__rootWithExpandedRow",
});
